/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CarbonCopy } from './CarbonCopy';
import {
    CarbonCopyFromJSON,
    CarbonCopyFromJSONTyped,
    CarbonCopyToJSON,
} from './CarbonCopy';
import type { MetadataField } from './MetadataField';
import {
    MetadataFieldFromJSON,
    MetadataFieldFromJSONTyped,
    MetadataFieldToJSON,
} from './MetadataField';
import type { Signer } from './Signer';
import {
    SignerFromJSON,
    SignerFromJSONTyped,
    SignerToJSON,
} from './Signer';

/**
 * 
 * @export
 * @interface CreateSignRequestData
 */
export interface CreateSignRequestData {
    /**
     * The reference number for the sign request
     * @type {string}
     * @memberof CreateSignRequestData
     */
    referenceNumber: string;
    /**
     * The subject of the email for the document
     * @type {string}
     * @memberof CreateSignRequestData
     */
    emailSubject: string;
    /**
     * The envelope metadata
     * @type {Array<MetadataField>}
     * @memberof CreateSignRequestData
     */
    metadata?: Array<MetadataField>;
    /**
     * The list of signers for the document
     * @type {Array<Signer>}
     * @memberof CreateSignRequestData
     */
    signers: Array<Signer>;
    /**
     * The list of cc recipients for the document
     * @type {Array<CarbonCopy>}
     * @memberof CreateSignRequestData
     */
    carbonCopies: Array<CarbonCopy>;
}

/**
 * Check if a given object implements the CreateSignRequestData interface.
 */
export function instanceOfCreateSignRequestData(value: object): boolean {
    if (!('referenceNumber' in value)) return false;
    if (!('emailSubject' in value)) return false;
    if (!('signers' in value)) return false;
    if (!('carbonCopies' in value)) return false;
    return true;
}

export function CreateSignRequestDataFromJSON(json: any): CreateSignRequestData {
    return CreateSignRequestDataFromJSONTyped(json, false);
}

export function CreateSignRequestDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateSignRequestData {
    if (json == null) {
        return json;
    }
    return {
        
        'referenceNumber': json['referenceNumber'],
        'emailSubject': json['emailSubject'],
        'metadata': json['metadata'] == null ? undefined : ((json['metadata'] as Array<any>).map(MetadataFieldFromJSON)),
        'signers': ((json['signers'] as Array<any>).map(SignerFromJSON)),
        'carbonCopies': ((json['carbonCopies'] as Array<any>).map(CarbonCopyFromJSON)),
    };
}

export function CreateSignRequestDataToJSON(value?: CreateSignRequestData | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'referenceNumber': value['referenceNumber'],
        'emailSubject': value['emailSubject'],
        'metadata': value['metadata'] == null ? undefined : ((value['metadata'] as Array<any>).map(MetadataFieldToJSON)),
        'signers': ((value['signers'] as Array<any>).map(SignerToJSON)),
        'carbonCopies': ((value['carbonCopies'] as Array<any>).map(CarbonCopyToJSON)),
    };
}

